export const Description: React.FC = ({ children }) => {
  return (
    <p className="text-base leading-8 text-center max-w-4xl lg:text-xl lg:leading-8 font-inter">{children}</p>
  )
}
